// @flow

import React from "react";
import { localize } from "redux-i18n";

import { Chart } from "@components";
import type { ComplianceReportData } from "@modules/reporting/reducer/trends/compliance/types";

type OwnProps = $Exact<{
  reportData: ComplianceReportData,
  weeklyPeriod: boolean,
  reportDetails: Object,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export const TrendComplianceChart = ({ reportData, t, weeklyPeriod, reportDetails }: Props) => {
  const trendType = ((reportDetails || {}).filters || {}).complianceType || "";
  const options = weeklyPeriod
    ? {
        xAxis: {
          labelRotation: 300,
        },
      }
    : {};
  return (
    <Chart
      type="ColumnChart"
      title={t("TRENDS_COMPLIANCE_HEADLINES_LABEL", { trendName: t(trendType) })}
      values={[
        ["Type", t(trendType), { role: "annotation" }],
        ...((reportData.headlines || {}).periods || []).map(item => [
          item.period,
          item.compliancePercentage,
          item.compliancePercentage,
        ]),
      ]}
      options={{
        vAxis: {
          title: t("COMPLIANCE_PERCENTAGE"),
        },
        legend: {
          position: "none",
        },
      }}
    />
  );
};

export default localize()(TrendComplianceChart);
